import { Directive, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[phoneMask]',
  standalone: false,
  providers: [
    { provide: NG_VALIDATORS, useExisting: PhoneDirective, multi: true }
  ]
})
export class PhoneDirective implements Validator {

  constructor() {}

  validate(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value?.replace(/\D/g, '');
    if (!value) return null;

    // Telefone com 10 ou 11 dígitos (excluindo DDD)
    if (value.length < 10 || value.length > 11) {
      return { telefoneInvalido: true };
    }

    return null;
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    if (event.inputType && event.inputType.includes('deleteContent')) return;

    const input = event.target;
    const cleaned = input.value.replace(/\D/g, '').substring(0, 11);

    let formatted = '';

    if (cleaned.length <= 2) {
      formatted = `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      formatted = `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    } else if (cleaned.length <= 10) {
      formatted = `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    } else {
      formatted = `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
    }

    input.value = formatted;
  }
}